import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import type { InvestigationEntity } from '../../../domain/entities/investigation.entity';

export interface GetInvestigationForPrintQuery { investigationId: string; }

export interface GetInvestigationForPrintResult {
  investigation: InvestigationEntity;
  fieldValues: { label: string; value: string; sortOrder: number }[];
  involvedEmployees: { firstName: string; lastName: string; email: string }[];
}

@Injectable({ providedIn: 'root' })
export class GetInvestigationForPrintUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(query: GetInvestigationForPrintQuery): Observable<GetInvestigationForPrintResult> {
    return this._repository.getInvestigationForPrint(query.investigationId).pipe(
      catchError((error) => throwError(() => error)),
    );
  }
}
